import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Box, Typography, TextField } from '@mui/material';

ReliableBookingTypeForm.propTypes = {
  setRule: PropTypes.func,
  formValue: PropTypes.object,
};

const ruleIds = {
  useGroupId: 22
};

export default function ReliableBookingTypeForm({ formValue, setRule }) {

  const rules = useMemo(() => {
    if (!formValue.rules) return {};
    return { useGroupId: formValue.rules.find(rule => rule.id === ruleIds.useGroupId) };
  }, [formValue.rules]);

  return <>
    <Box>
      <Typography variant="subtitle1">
        Group
      </Typography>
      <Tooltip title="Group id/name used to distinguish between integrations" arrow placement="left">
        <TextField
          size="small"
          value={rules.useGroupId?.value ?? ""}
          onChange={(e) => setRule(ruleIds.useGroupId, e.target.value ? { id: ruleIds.useGroupId, value: e.target.value } : null)}
          fullWidth
        />
      </Tooltip>
    </Box>
  </>;
}